@if (view$ | async; as view) {
    <mobi-ui-messages-major>
        @for (message of view.messages; track message) {
            <mobi-ui-message-item-major
                [level]="message.level"
                (click)="clearMessage(message)"
                [ngClass]="{ 'fade-out': message.fadeOut | async }"
            >
                {{ message.text | translate }}
            </mobi-ui-message-item-major>
        }
    </mobi-ui-messages-major>
}
